import * as yup from "yup";
import { formatBytes } from "shared/utils";
import { useState } from "react";

export const filesValidationsSchema = {
  files: {
    attachments_allowed_file_types: [],
    max_allowed_file_size_in_bytes: 2097152, // 2MB'
  },
};

/**
 * @deprecated Do not use this hook. src/shared/ui/FilesInput component contains all required validation logic
 */
export function useFilesValidations() {
  const [filesValidations, setFilesValidations] = useState(
    filesValidationsSchema
  );
  const filesValidationSchema = yup
    .mixed()
    .test("files", "Invalid files data", function (files) {
      if (files?.length) {
        const sortedFiles = files?.reduce(
          (acc, file, idx, self) => {
            if (file.action === "updateAttachment") {
              acc.filesToUpdate.push(file);
            } else if (file.action === "storeAttachment") {
              acc.filesToStore.push(file);
            } else if (file.action === "deleteAttachment") {
              if (
                self.some(
                  (f) => f.action === "updateAttachment" && f.id === file.id
                )
              )
                return acc;
              acc.filesToDelete.push(file);
            } else {
              acc.stored.push(file);
            }
            return acc;
          },
          {
            filesToUpdate: [],
            filesToStore: [],
            filesToDelete: [],
            stored: [],
          }
        );
        const filesLength = sortedFiles.stored.concat(
          sortedFiles.filesToStore,
          sortedFiles.filesToUpdate
        );
        if (
          filesLength.length >
          filesValidations.files.attachments_count_rules?.max
        )
          return this.createError({
            message: `No more than ${filesValidations.files.attachments_count_rules?.max} files are allowed`,
          });

        const filesToValidate = sortedFiles.filesToUpdate.concat(
          sortedFiles.filesToStore
        );
        if (
          !filesToValidate.every(({ file }) =>
            filesValidations?.files?.attachments_allowed_file_types?.includes(
              file.name.split(".").pop().toLowerCase()
            )
          )
        ) {
          return this.createError({
            message: "Not a valid image type",
          });
        }

        if (
          !filesToValidate.every(
            ({ file }) =>
              file.size <= filesValidations.files.max_allowed_file_size_in_bytes
          )
        ) {
          return this.createError({
            message: `Files can't be larger than ${formatBytes(
              filesValidations.files.max_allowed_file_size_in_bytes
            )}.`,
          });
        }
      }
      return true;
    });

  return { filesValidations, setFilesValidations, filesValidationSchema };
}
